import React, { useEffect, useState } from 'react'
import {
  Form,
  Radio,
} from 'antd'

import './index.styl'

const { Item } = Form

const Footer = ({ form, currentPageDetails }) => {
  const [selectedOption, setSelectedOptions] = useState('BUYER')
  const onValueChange = event => {
    setSelectedOptions(event.target.value)
  }
  useEffect(() => {
    form.setFieldsValue({
      paymentProcessorFee: currentPageDetails?.fees?.paymentProcessorFee || 'BUYER',
    })
  }, [currentPageDetails])
  return (
    <div className='MemberLyfefooterWrapper'>
      <div className='titleFees'>Fees</div>
      <div className='feesItemWrapper'>
        <div className='memberLyfeFeeText'>The Member Lyfe Fee is 1%. For GIFTS and Cash/Zelle sales is 1% up to $1.00.</div>
        <Item
          name='paymentProcessorFee'
          label='Payment Processing Fee Will be Paid by'
          initialValue={selectedOption}
          className='itemFee'
        // initialValue={currentEventDetails?.fees?.paymentProcessorFee}
        >
          <Radio.Group // disabled while draft creation/edition (draft event edited by venue user)
            onChange={onValueChange}
            value={selectedOption}
            className='radioFees'
          >
            <Radio value='BUYER'>
              <div className='radioText buyer'>Buyer of Ticket</div>
            </Radio>
            <Radio value='PROMOTER'>
              <div className='radioText'>Owner</div>
            </Radio>
          </Radio.Group>
        </Item>
      </div>
    </div>
  )
}

export default Footer
